import { map, pick, isArray, isString } from 'lodash-es'

export function getFile(file) {
  return {
    ...pick(file, ['name', 'size', 'type']),
    file,
    status: 'pending',
  }
}

export function getFiles(files) {
  const tmp = []
  for(let i = 0; i < files.length; i++) {
    tmp.push(getFile(files[i]))
  }

  return tmp
}

/**
 * 将image转换成base64，并一起返回文件信息
 */
export function getBase64Items(files) {
  return new Promise((resolve) => {
    const tmp = []
    
    function emit() {
      if (tmp.length === files.length) {
        resolve(
          map(tmp, ({ url, file }) => ({ ...getFile(file), url }))
        )
      }
    }
    
    for(let i = 0; i < files.length; i++) {
      const file = files[i]
      const reader = new FileReader()

      reader.onload = (e) => {
        tmp.push({ file, url: e.target.result })
        emit()
      }

      reader.onerror = () => {
        tmp.push({ file })
        emit()
      }

      reader.readAsDataURL(file)
    }
  })
}

/**
 * 输入一个数组(字符串),里面是url字符串
 * 返回一个数据对象，里面包括文件上传状态
 * 
 * 主要用于文件上传列表初始化
 */
export function initialImages(images) {
  const tmp = []
  if(!images) return tmp
  if(isString(images)) return [tmp]

  isArray(images) && images.forEach((url) => url && tmp.push({ 
    url, 
    name: url, 
    status: 'finish'
  }))

  return tmp
}
